import { type CreateAgenteModel, type DetailAgenteModel, type DireccionModel } from '@api/api';

export class CreateAgente implements CreateAgenteModel {

  Nombre: string = '';
  Apellidos: string = '';
  Email: string = '';
  Documento: string = '';
  Telefono: string = '';
  IdEmpresaAgentes: string | null = null; 
  Direccion: DireccionModel = {
    CodigoPostal: null,
    Provincia: null,
    Municipio: null,
    TipoVia: null,
    NombreVia: null,
    Numero: null,
    Escalera: null,
    Piso: null,
    Puerta: null
  };

  constructor(data?: Partial<CreateAgente>) {
    Object.assign(this, data);
  }

  public createFromAgenteDetail(agente: DetailAgenteModel): CreateAgente{
    Object.assign(this, agente);
    return this;
  }

}